import {FC, useEffect} from 'react';

import {usePushControllerContext} from '../../../../../libs/shared/ui/src/push/pushControllerContext';
import {buildIsWindowVisible$} from '../../../../../srcCommon/push/pushCommons';

export const DesktopReconnection: FC = () => {
  const {pushController} = usePushControllerContext();
  useEffect(() => {
    const subscription = buildIsWindowVisible$().subscribe(() => {
      pushController.connect();
    });
    return () => subscription.unsubscribe();
  }, [pushController]);
  return null;
};
